import { render, staticRenderFns } from "./PackageDetailsTable.vue?vue&type=template&id=f0c6841e"
import script from "./PackageDetailsTable.vue?vue&type=script&lang=js"
export * from "./PackageDetailsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports